export default __webpack_public_path__ + "static/educatorThumb-52cf84921c2c4a62c807e9a7a679da0b.jpg";